var map = {
	"./decidim/avatar-multiuser.png": 41883,
	"./decidim/brands/facebook.svg": 35955,
	"./decidim/brands/google.svg": 13642,
	"./decidim/brands/twitter-x.svg": 11195,
	"./decidim/cc-badge.png": 20393,
	"./decidim/decidim-logo.svg": 29769,
	"./decidim/default-avatar.svg": 73625,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 16383,
	"./decidim/icons.svg": 56920,
	"./decidim/pattern.png": 51819,
	"./decidim/placeholder-card-g.svg": 14840,
	"./decidim/placeholder-card-l.svg": 30067,
	"./decidim/placeholder.jpg": 11994,
	"./decidim/remixicon.symbol.svg": 79712,
	"./decidim/vendor/social-share-button/douban.svg": 39859,
	"./decidim/vendor/social-share-button/email.svg": 57452,
	"./decidim/vendor/social-share-button/facebook.svg": 38072,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 99356,
	"./decidim/vendor/social-share-button/hacker_news.svg": 54720,
	"./decidim/vendor/social-share-button/linkedin.svg": 28074,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 57747,
	"./decidim/vendor/social-share-button/pinterest.svg": 59706,
	"./decidim/vendor/social-share-button/reddit.svg": 22256,
	"./decidim/vendor/social-share-button/telegram.svg": 22837,
	"./decidim/vendor/social-share-button/tumblr.svg": 82258,
	"./decidim/vendor/social-share-button/twitter.svg": 16777,
	"./decidim/vendor/social-share-button/vkontakte.svg": 43555,
	"./decidim/vendor/social-share-button/wechat.svg": 43758,
	"./decidim/vendor/social-share-button/whatsapp.svg": 8774,
	"./decidim/vendor/social-share-button/x.svg": 78500,
	"./decidim/vendor/social-share-button/xing.svg": 27220
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31748;